export default __webpack_public_path__ + "static/media/TX_Elemental_Fire_Grimory.b93fb34b.png";